import React, { useEffect, useState } from 'react';
import { withRouter } from 'next/router';
import dynamic from 'next/dynamic';
import {
  useStateValue,
  setIsIframe,
  setHasHeaderNotification,
  setPublisher,
} from '../../state/stateProvider';
import Loader from '../../components/Loader/Loader';
import useUser from '../../hooks/use-user';
import useDevice from '../../hooks/useDevice';

import styles from './templates.module.scss';

const {
  templatesMainFrame, templatesSkeleton, isOnIframe, hasTrialBar,
} = styles;

// Loading Header component when WINDOW is available
// since header uses window object to generate
const DynamicHeader = dynamic(
  () => import('../../components/MainHeader/Header'),
  { ssr: false },
);

const TemplatesLayout = ({ children, router }) => {
  const [{ isLoading, isIframe, hasHeaderNotification }, dispatch] = useStateValue();

  const { isDesktop } = useDevice();
  const { user } = useUser();
  const { inApp } = router.query;

  useEffect(() => {
    const elem = document.getElementsByTagName('body')[0];
    elem.classList.add('templates-page');
  }, []);

  useEffect(() => {
    if (inApp === 'true') {
      setIsIframe(dispatch, true);
    }
  }, [router?.query]);

  const [, setSwitchedChannel] = useState('');
  const [hasACGNotification, setHasACGNotification] = useState(false);
  const [hasTrialNotification, setHasTrialNotification] = useState(false);
  const [canRenderHeader, setCanRenderHeader] = useState(false);

  const handleNotification = (hasTrialNtf, hasACGNtf) => {
    setHasTrialNotification(hasTrialNtf);
    setHasACGNotification(hasACGNtf);
    setHasHeaderNotification(dispatch, hasTrialNtf || hasACGNotification);
  };

  const handleAcgNotification = (hasACGNtf) => {
    handleNotification(hasTrialNotification, hasACGNtf);
  };

  const handleEndTrial = (shouldRest, hasTrialNtf) => {
    handleNotification(hasTrialNtf, hasACGNotification);
  };

  const onChannelSwitched = (value) => {
    const publisherData = {
      selectedPublisherId: value,
      engines: []
    }
    setPublisher(dispatch, publisherData);
    setSwitchedChannel(value);
  };

  useEffect(() => {
    setCanRenderHeader(isDesktop && !isIframe && user && user.userId);
  }, [isDesktop, isIframe, user]);

  /**
   * Adjusting skeleton frame margin in case header has Trial or any other notification
   */
  const adjustSkeletonIfRequired = () => {
    if (!canRenderHeader) {
      return isOnIframe;
    }
    return hasHeaderNotification ? hasTrialBar : '';
  };

  return (
    <>
      {isLoading && <Loader />}
      <div>
      { canRenderHeader
              && <DynamicHeader onChannelSwitched={onChannelSwitched}
                                handleEndTrial={handleEndTrial}
                                setAcgNotification={handleAcgNotification} /> }
        <section className={`${templatesMainFrame} ${!canRenderHeader ? isOnIframe : ''}`}>
          <div className={`${templatesSkeleton} ${adjustSkeletonIfRequired()}`}>{children}</div>
        </section>
      </div>
    </>
  );
};

export default withRouter(TemplatesLayout);
